import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"
import {
  Layout,
  Page,
  Card,
  LegacyCard,
  DataTable,
  Button,
  Text,
  EmptyState,
  SkeletonBodyText,
  InlineStack,
  Banner,
} from "@shopify/polaris";
import { EditIcon, DeleteIcon, DuplicateIcon } from "@shopify/polaris-icons";
import Axios from "./common/Axios";
import { toast } from "react-toastify";

export function Profile() {
  const [profiles, setProfiles] = useState([]);
  const [profileData, setprofileData] = useState(false);
  const navigate = useNavigate();
  const [showInfo,setShowInfo] = useState(true);
  useEffect(() => {
    fetchprofile();
  }, []);
  const handleDeleteProfile = async(profileId)=>{
        const response = await Axios.post(`/profile/deleteProfile/${profileId}`);
        toast.success(response.data.message);
        fetchprofile();
  }
  const handleDuplicateProfile = async(profileId)=>{
    try {
       const response = await Axios.post(`/profile/copyProfile/${profileId}`);
        toast.success(response.data.message);
        fetchprofile();
    } catch (error) {
      if (error?.response?.status === 406) {
                  toast.error(error?.response?.data?.error?.msg[0]);
      }
    }
       
  }
  const fetchprofile = async () => {
    const response = await Axios.get('/getprofiles');
    setProfiles(response.data);
    setprofileData(true);
  };

  const rows = profiles.map((profile) => [
    <Text key={`name-${profile.id}`} fontWeight="bold">
      {profile.name} {profile.is_default_profile ? "(default)" : ""}
    </Text>,
    <InlineStack align="start">
      <Button key={`edit-${profile.id}`} variant="primary" icon={EditIcon} size="large" onClick={() => navigate(`${process.env.REACT_APP_BASE_URL}/Editprofile/${profile.id}`)}/>
    </InlineStack>,
    <InlineStack align="start">
      <Button key={`delete-${profile.id}`} variant="secondary" tone="critical"onClick={() => handleDeleteProfile(profile.id) } 
icon={DeleteIcon} size="large" disabled={profiles.length === 1} />
    </InlineStack>,
    <InlineStack align="start">
      <Button key={`duplicate-${profile.id}`} variant="secondary" icon={DuplicateIcon} size="large" onClick={() => handleDuplicateProfile(profile.id)}/>
    </InlineStack>,
  ]);
let content;
 const handleAddProfile = () => {
    navigate(`${process.env.REACT_APP_BASE_URL}/addprofile`);
  };
if (!profileData) {
  content = <SkeletonBodyText lines={10} />;
} else if (profiles.length === 0) {
  content =      
      <EmptyState
        heading="No Profile Found"
        action={{content: 'Add Profile',onAction:handleAddProfile }}

        image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
        fullWidth
      >
         <Text variant="bodyLg" as="p">
                A profile is required to import products into eBay. Please create a profile to proceed with importing your products successfully.

      </Text>
       
      </EmptyState>
} else {
  content = (
    <DataTable
      columnContentTypes={["text", "text", "text", "text"]}
      headings={["Name", "Edit", "Delete", "Duplicate"]}
      rows={rows}
    />
  );
}
  return (
    <Layout>
      <Layout.Section>  
        <Page fullWidth title="All profiles" 
         primaryAction={<Button variant="primary" onClick={() => navigate(`${process.env.REACT_APP_BASE_URL}/addprofile/`)}>Add profile</Button>}
        >
            <div style={{ width: "100%", marginRight: "20px", marginBottom: "20px" }}>
                {showInfo &&(
                <Banner tone="info" onDismiss={() => {setShowInfo(false)}}>
                  <strong>Please note:</strong>  The Profile section is only needed when importing products from Shopify to eBay.
                </Banner>
                )}
            </div>
          <Card>
          {content}
 
          </Card>
        </Page>
      </Layout.Section>
    </Layout>
  );
}
